import React from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container, Row } from 'react-bootstrap';
import ReusableProduct from '../organic1-reusable/ReusableProduct';
import "../product/Products.css"
const Product = () => {
  return (
    <>
    <section id="product">
      <Container>
        <h1>All Category Product</h1>
        <Tabs defaultActiveKey="featured" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="featured" title="Vegetables">
            <Row style={{rowGap: "20px"}}>
              <ReusableProduct img="imeges/desktop1/Product Category.png" />
              <ReusableProduct img="imeges/desktop1/Product Category strowbarry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category  orange.png" />
              <ReusableProduct img="imeges/desktop1/Product Category tomatoo.png" />
              <ReusableProduct img="imeges/desktop1/Product Category blackberry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category lamon.png" />
            </Row>
          </Tab>
          <Tab eventKey="latest" title="Fruits">
            <Row style={{rowGap: "20px"}}>
              <ReusableProduct img="imeges/desktop1/Product Category.png" />
              <ReusableProduct img="imeges/desktop1/Product Category strowbarry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category  orange.png" />
              <ReusableProduct img="imeges/desktop1/Product Category tomatoo.png" />
              <ReusableProduct img="imeges/desktop1/Product Category blackberry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category lamon.png" />
            </Row>
          </Tab>
          <Tab eventKey="best-seller" title="Organic">
            <Row style={{rowGap: "20px"}}>
              <ReusableProduct img="imeges/desktop1/Product Category.png" />
              <ReusableProduct img="imeges/desktop1/Product Category strowbarry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category  orange.png" />
              <ReusableProduct img="imeges/desktop1/Product Category tomatoo.png" />
              <ReusableProduct img="imeges/desktop1/Product Category blackberry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category lamon.png" />
            </Row>
          </Tab>
          <Tab eventKey="special" title="Elementum">
            <Row style={{rowGap: "20px"}}>
              <ReusableProduct img="imeges/desktop1/Product Category.png" />
              <ReusableProduct img="imeges/desktop1/Product Category strowbarry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category  orange.png" />
              <ReusableProduct img="imeges/desktop1/Product Category tomatoo.png" />
              <ReusableProduct img="imeges/desktop1/Product Category blackberry.png" />
              <ReusableProduct img="imeges/desktop1/Product Category lamon.png" />
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </section>
    </>
  )
}

export default Product

